import React from 'react';

import DOMPurify from 'dompurify';

export default function DisplayContext (props)
{
    let { contextType, masthead, message, details } = props;
    const mainclassname = `messagenotification ${contextType}`;
    let iconcss = '';
    masthead = masthead || props.contextType?.toUpperCase() || '';

    switch (props.contextType)
    {
        case 'error':
            iconcss = 'bi bi-x-circle-fill';
            break;
        case 'success':
            iconcss = 'bi bi-check-circle-fill';
            break;
        case 'warning':
            iconcss = 'bi bi-exclamation-circle-fill';
            break;
        default:
            iconcss = 'bi bi-info-circle-fill';
            break;
    }

    // Helper function to safely render HTML or plain text
    const renderContent = (content) => {
        if (typeof content === 'string' && (content.includes('<') || content.includes('&')))
        {
            content = DOMPurify.sanitize(content, { USE_PROFILES: { html: true } });
            return <span dangerouslySetInnerHTML={{ __html: content }} />;
        }

        return content;
    };

    // Helper function to render detail items with HTML support
    const renderDetailItem = (item, key) => {
        if (typeof item === 'string' && (item.includes('<') || item.includes('&')))
        {
            item = DOMPurify.sanitize(item, { USE_PROFILES: { html: true } });
            return <li key={key} dangerouslySetInnerHTML={{ __html: item }} />;
        }

        return <li key={key}>{item}</li>;
    };

    return (
        <div className={mainclassname}>
            <div data-role="iconcontainer">
                <table>
                    <tbody>
                        <tr>
                            <td className="iconcell">
                                <span className={iconcss}>
                                    <span>{contextType}</span>
                                </span>
                            </td>
                            <td className="contentcell">
                                <div data-role="contentcontainer">
                                    {
                                        masthead.length > 0 &&
                                        <div data-role="masthead">{renderContent(masthead)}</div>
                                    }
                                    {
                                        message.length > 0 &&
                                        <div data-role="standardmessage">{renderContent(message)}</div>
                                    }
                                    {
                                      details.length > 0 &&
                                        <div data-role="messagelistcontainer">                                            
                                            <ul className="detailslist">
                                                {
                                                    (details.map((item, key) => { return renderDetailItem(item, key); }))
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>    
    );
}